import React from "react";
import "../Player.css";
import ImprintDataPrivacyContactBody from "./ImprintDataPrivacyContactBody";

function ImprintDataPrivacyContact () {
  return (
    <div className="player">
      <div className="player__body">
        <ImprintDataPrivacyContactBody/>
      </div>
    </div>
  );
}

export default ImprintDataPrivacyContact;
